import React from 'react'
import { X } from 'react-feather';
import { useViewport } from '../utils';
import colors from '../utils/colors';

const RelatedItem = ({value, onClose}) => {
  const { isMobile } = useViewport()

  return (
    <div className="border rounded flex items-center justify-between px-2 lg:px-3 py-1 lg:py-2" style={{borderColor: colors.blue}}>
      <p className={`leading-none lg:leading-tight text-xs lg:text-sm text-gray-444 ${onClose ? 'pr-2 lg:pr-3' : ''}`}>{value}</p>
      {
        onClose &&
        <button type="button" className="appearance-none outline-none" onClick={onClose}>
          <X width={isMobile ? 14 : 16} />
        </button>
      }
    </div>
  )
}

export { RelatedItem }
